import { render, staticRenderFns } from "./ProductTypeBase.vue?vue&type=template&id=22b878fa&"
import script from "./ProductTypeBase.vue?vue&type=script&lang=js&"
export * from "./ProductTypeBase.vue?vue&type=script&lang=js&"
import style0 from "./ProductTypeBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports